import {
    scrollTo
} from '../../../application/typescript/utils/utils';

class BlockAnchor {
    constructor() {
        this._init();
    }

    _init() {
        var self = this;
        document.addEventListener('DOMContentLoaded', function () {
            const anchor = document.querySelectorAll('.anchor');
            anchor.forEach(function (nav) {
                const anchorItems = document.querySelectorAll<HTMLButtonElement>('.anchor__item');
                self._anchorClick(anchorItems);
                self._onScroll(anchorItems);
                window.addEventListener('scroll', function () {
                    self._onScroll(anchorItems)
                });
            });
        });

    }

    _anchorClick(anchorItems: NodeListOf<HTMLButtonElement>) {
        anchorItems.forEach((item) => {
            item.addEventListener('click', (event: MouseEvent) => {
                const target = event.currentTarget as HTMLButtonElement;
                const anchorId = target.getAttribute('data-anchor');
                if (anchorId) {
                    const targetElement = document.getElementById(anchorId);
                    if (targetElement) {
                        scrollTo(targetElement);
                        // anchorItems.forEach((anchor) => anchor.classList.remove('anchor__item--active')); 
                        // target.classList.add('anchor__item--active');
                    }
                }
            });
        })
    }

    _onScroll(anchorItems: NodeListOf<HTMLButtonElement>) {
        let currentActiveAnchor: HTMLButtonElement | null = null;

        anchorItems.forEach((item) => {
            const anchorId = item.getAttribute('data-anchor');
            if (anchorId) {
                const targetElement = document.getElementById(anchorId);

                if (targetElement) {
                    const rect = targetElement.getBoundingClientRect();
                    // Trouver l'élément actif
                    if (rect.top <= window.innerHeight && rect.bottom >= 0) {
                        currentActiveAnchor = item;
                    }
                }
            }
        });

        if (currentActiveAnchor) {
            anchorItems.forEach((item) => {
                item.classList.remove('anchor__item--active');
            });
            (currentActiveAnchor as HTMLButtonElement).classList.add('anchor__item--active');
        }
    }

}

export const blockAnchor = new BlockAnchor();
